import { AdgangAdresseSted, EjendomSted, EnhedSted, MatrikelSted, Sted } from 'src/app/api/models';

export class StedHelper {
  static getMatrikelSted(sted: Sted): MatrikelSted {
    switch (sted.type) {
      case 'AdgangAdresseSted':
        return (sted as AdgangAdresseSted)?.matrikel;
      case 'EnhedSted':
        return (sted as EnhedSted)?.adgangAdresse?.matrikel;
      case 'EjendomSted':
        return (sted as EjendomSted)?.adgangAdresse?.matrikel;
      case 'MatrikelSted':
        return sted as MatrikelSted;
      default:
        return null;
    }
  }

  static getMatrikler(sted: Sted): MatrikelSted[] {
    switch (sted.type) {
      case 'AdgangAdresseSted':
        return [(sted as AdgangAdresseSted)?.matrikel];
      case 'EnhedSted':
        return [(sted as EnhedSted)?.adgangAdresse?.matrikel];
      case 'EjendomSted':
        return (sted as EjendomSted)?.matrikler ?? [(sted as EjendomSted)?.adgangAdresse?.matrikel];
      case 'MatrikelSted':
        return [sted as MatrikelSted];
      default:
        return null;
    }
  }
}
